class WIdeliverydate extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.deliveryDate();    
    }

    // delivery date function
    deliveryDate() {
        const now = new Date();
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    let deliveryDate = new Date(now);
    
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const isAfter2PM = hours > 14 || (hours === 14 && minutes > 0);
    const day = now.getDay();
    
    if (day === 5 || day === 6 || day === 0) { 
        deliveryDate.setDate(now.getDate() + (day === 5 && !isAfter2PM ? 3 : 4));
    } else {
        deliveryDate.setDate(now.getDate() + (isAfter2PM ? 2 : 1));
    }
    
    let displayDate = new Intl.DateTimeFormat('en-US', options).format(deliveryDate);
    console.log(displayDate);
    this.innerHTML = `${displayDate}`;
    
    }

    // Hide date on option select 
    hideDate() {
        let varInputs = document.querySelectorAll('.option-selectors input');
        varInputs.forEach(inp => {
            
        });
        
        if (selectElement.value === '0') {
            deliveryDateElement.style.display = 'none';
        } else {
            deliveryDateElement.style.display = 'block';
        }
    }
}

customElements.define('wi-delivery-date', WIdeliverydate);